<template>
  <div class="selected-ruejai-club-package-list">
    <div class="header">
      <h4 class="count">เลือกแล้ว {{ count }} package</h4>
      <sc-button
        v-if="showRemoveAllButton"
        :disabled="disabledRemoveButton"
        class="remove-all-button"
        @click="handleClickRemoveAllButton"
        >ลบทั้งหมด</sc-button
      >
    </div>
    <div class="list-body">
      <div v-if="isEmpty" class="empty">ไม่มี package ที่เลือก</div>
      <ruejai-club-package-selector-option
        v-for="item in value"
        :key="item.id"
        v-bind="item"
        :can-remove="canRemove"
        class="selected-item"
        @remove="handleRemoveSelectPackage(item)"
      ></ruejai-club-package-selector-option>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import RuejaiClubPackageSelectorOption from "./RuejaiClubPackageSelectorOption";

export default {
  components: {
    RuejaiClubPackageSelectorOption,
    ScButton
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEmpty() {
      return this.value.length === 0;
    },
    count() {
      return this.value.length;
    },
    disabledRemoveButton() {
      return this.isEmpty || !this.canRemove;
    },
    canRemove() {
      return !this.disabled;
    },
    showRemoveAllButton() {
      return this.canRemove;
    }
  },
  methods: {
    handleRemoveSelectPackage(item) {
      this.$emit("remove", item);
    },
    handleClickRemoveAllButton() {
      this.$emit("removeAll");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.selected-ruejai-club-package-list {
  border: $border;
  border-radius: $border-radius;
}

.header {
  display: grid;
  grid-template-columns: 1fr auto;

  border-bottom: $border;

  > .remove-all-button {
    height: 42px;
    font-size: 0.8rem;
    color: #444;
    border: 0;
    border-radius: 0;
    border-top-right-radius: $border-radius;
    border-left: $border;

    &:hover,
    &:focus {
      border-color: #dcdfe6 !important;
    }
  }
}

.selected-ruejai-club-package-list > .list-body {
  overflow-y: auto;
  height: 500px;
}

.empty {
  padding: 20px 0;
  text-align: center;
}

.count {
  margin: 0;
  padding: 10px ($space / 2);

  color: $primary-color;
  font-size: 1.1rem;
  font-weight: bold;
}
</style>
